import React, { useEffect, useState } from "react";
import { uploadImageRequest } from "../../../http-request/uploadImageRequest";

import uploadIcon from "../../../assets/upload-icon.svg";
import classes from "./formUploadInput.module.css";
import { extractReadableLabel } from "../../../utils/buildQueryString";
import { testUploadImageRequest } from "../../../http-request/testUploadRequest";

export const FormUploadInput = ({
  id,
  urlLabel,
  url,
  onSelection,
  onChange,
  disabled,
  label,
  uploadType = "default", // 👈 "default" | "test" | "other"
  extraParams = {}, // 👈 optional parameters for custom upload APIs
}) => {
  const [uploadImage, setUploadImage] = useState("");
  const [ext, setExt] = useState("");

  // Sync `uploadImage` state with the `url` prop
  useEffect(() => {
    if (url) {
      setUploadImage(url);
    }
  }, [url]);

  const fileUpload = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    try {
      let response;

      // Choose upload request based on type
      if (uploadType === "test") {
        response = await testUploadImageRequest(selectedFile, extraParams);
      } else {
        response = await uploadImageRequest(selectedFile);
      }

      const imageUrl = response?.data?.fileUrl;
      const showUrl = extractReadableLabel(imageUrl);

      // Update state and notify parent
      setUploadImage(imageUrl);
      if (onChange) onChange(id, imageUrl);
      if (onSelection) onSelection(imageUrl);
      setExt(showUrl);
    } catch (error) {
      console.error(`File upload failed for ${id}:`, error);
    }
  };

  return (
    <div className={classes.form__group__upload}>
      {label && <h4 className={classes.form__group__label}>{label}</h4>}
      <label
        htmlFor={`upload-${id}`}
        className={classes.form__field__upload__label}
      >
        <img src={uploadIcon} alt="upload" className={classes.upload__img} />
        <h3 className={classes.upload__label}>Upload File</h3>
        <input
          name={`upload-${id}`}
          type="file"
          id={`upload-${id}`}
          className={classes.form__field__upload}
          onChange={fileUpload}
          disabled={disabled}
        />
      </label>
      <span className={classes.uploadedUrl}>{ext || urlLabel}</span>
    </div>
  );
};
